import defaultStyleJson from '@/components/NioMap/assets/defaultStyleJson.json'
export default {
  ak: 'mpIkrnTCGbrxBP4sn8qh3toBGvYWD0lm',
  scrollWheelZoom: true, // 启用滚轮放大缩小,
  pinchToZoom: true, // 启用双指放大缩小
  theme: defaultStyleJson, // 主题
}
